import { render, staticRenderFns } from "./hey-jessica.vue?vue&type=template&id=27fe54d2&scoped=true&"
import script from "./hey-jessica.vue?vue&type=script&lang=js&"
export * from "./hey-jessica.vue?vue&type=script&lang=js&"
import style0 from "./hey-jessica.vue?vue&type=style&index=0&id=27fe54d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe54d2",
  null
  
)

export default component.exports